export const normalizeExamName = (exam: string): string => {
  if (!exam) {
    return '';
  }

  // if the exam name contains a '/', we take the part after it, otherwise we take the whole name
  const examPart = exam.includes('/') ? exam.split('/')[1] : exam;

  // delete the versioning part (@x)
  return examPart.split('@')[0];
};
